import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(2),
    maxWidth: 320,
    borderRadius: theme.spacing(1),
    pointerEvents: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(1),
  },
  infoIcon: {
    color: theme.palette.info.main,
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 'normal',
  },
  betaChip: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
  },
  description: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  note: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
    fontStyle: 'italic',
  },
}))

export default styles
